<template>
    <div v-if="!projectData.template" class="wg-row com-anm22-tasks-project-bar" :style="'border-left:4px solid ' + borderColor">
      <router-link :to="'/project/'+(projectData.id)" class="wg-row" style="height:100%;">
        <template v-if="view === 'full'">
          <div class="wg-col wg-xs-none wg-sm-2" style="padding:10px;">
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
              <img 
                  v-if="!isSynchronized"
                  :src="$anm22.icons.getWorldIcon('offline')"
                  class="com-anm22-app-img-fixed-height-s"
                  style="margin-right:5px;"
                  :title="$anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')"
              >
              <img 
                  v-if="projectData.urgent"
                  :src="$anm22.icons.getWorldIcon('priorityHighest')"
                  class="com-anm22-app-img-fixed-height-s"
                  style="margin-right:5px;"
                  :title="$anm22.tableClasses.taskPriority().getById(5)[lang]"
              >
              <img 
                  v-if="typeof projectData.id === 'string'"
                  :src="$anm22.icons.getWorldIcon('offline')"
                  class="com-anm22-app-img-fixed-height-s"
                  style="margin-right:5px;"
                  :title="$anm22.strLang(lang, 'Element not synced', 'Elemento non sincronizzato')"
              >
              <div class="com-anm22-app-text-m projectName" style="font-weight:bold;">
                  {{ projectData.projectId || '-' }}
              </div>
            </div>
          </div>
          <div class="wg-col wg-xs-none wg-sm-3" style="padding:10px;" :title="projectHoverTitle(projectData)">
            <div class="com-anm22-app-text-m projectName" style="font-weight:bold;">
              {{ projectData.name || $anm22.strLang(lang, "Project", "Progetto") }}
            </div>
          </div>
          <div class="wg-col wg-xs-7 wg-sm-none" style="padding:10px;" :title="projectHoverTitle(projectData)">
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
              <img 
                  v-if="projectData.urgent"
                  :src="$anm22.icons.getWorldIcon('priorityHighest')"
                  class="com-anm22-app-img-fixed-height-s"
                  style="margin-right:5px;"
                  :title="$anm22.tableClasses.taskPriority().getById(5)[lang]"
              >
              <img 
                  v-if="typeof projectData.id === 'string'"
                  :src="$anm22.icons.getWorldIcon('offline')"
                  class="com-anm22-app-img-fixed-height-s"
                  style="margin-right:5px;"
                  :title="$anm22.strLang(lang, 'Element not synced', 'Elemento non sincronizzato')"
              >
              <div class="com-anm22-app-text-m projectName" style="font-weight:bold;">
                  {{ projectData.codeName }}
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="wg-col wg-xs-7" style="padding:10px;" :title="projectHoverTitle(projectData)">
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
              <img 
                  v-if="projectData.urgent"
                  :src="$anm22.icons.getWorldIcon('priorityHighest')"
                  class="com-anm22-app-img-fixed-height-s"
                  style="margin-right:5px;"
                  :title="$anm22.tableClasses.taskPriority().getById(5)[lang]"
              >
              <img 
                  v-if="typeof projectData.id === 'string'"
                  :src="$anm22.icons.getWorldIcon('offline')"
                  class="com-anm22-app-img-fixed-height-s"
                  style="margin-right:5px;"
                  :title="$anm22.strLang(lang, 'Element not synced', 'Elemento non sincronizzato')"
              >
              <div class="com-anm22-app-text-m projectName" style="font-weight:bold;">
                  {{ projectData.codeName }}
              </div>
            </div>
          </div>
        </template>
        <!-- Utenti con il permesso di accesso -->
        <div class="wg-col wg-xs-2 users-div">
          <div 
              v-for="(user,index) in projectUsers"
              :key="'u-'+index">
            <world-object-icon
                :type="'user'" 
                :obj="user"
                :isImg="true">
            </world-object-icon>
          </div>
          <div v-for="(job,index) in projectJobs" :key="'job'+index">
            <div :title="$anm22.strLang(lang, job.en, job.it)" class="job-icon"> {{ $anm22.strLang(lang, job.en, job.it).substring(0,1).toUpperCase() }} </div>
          </div>
        </div>
        <!-- Stato del progetto -->
        <template v-if="view === 'full'">
          <div class="wg-col wg-xs-none wg-sm-1">
            <div 
                :class="[
                  'com-anm22-app-align-center', 
                  'status', 
                  $anm22.tableClasses.projectStatus().getById(projectData.status).typeClassLiteral
                ]"
                style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
              {{ $anm22.tableClasses.projectStatus().getById(projectData.status)[lang] }}
            </div>
          </div>
          <div class="wg-col wg-xs-none wg-sm-2">
            <div class="display-flex date-div" style="height:100%;flex-wrap:nowrap;align-items:center;">
              <div class="com-anm22-app-text-l" :title="projectData.startDate ? $moment.unix(projectData.startDate).utc().format('DD MMMM YYYY') : ''">
                {{ projectData.startDate ? $moment.unix(projectData.startDate).utc().format(view === 'full' ? 'D MMM YYYY' : 'D MMM') : ''}}
              </div>
            </div>
          </div>
        </template>
        <!-- Termine del progetto -->
        <div class="wg-col wg-xs-3 wg-sm-2">
          <div class="display-flex date-div" style="height:100%;flex-wrap:nowrap;align-items:center;">
            <div 
                class="com-anm22-app-text-l"
                :style="{color: projectData.deadline !== projectData.endDate ? '#00B0FF' : ''}" 
                :title="projectData.deadline ? $moment.unix(projectData.deadline).utc().format('DD MMMM YYYY') : ''">
              {{ 
                projectData.deadline 
                  ? $moment.unix(projectData.deadline).utc().format(windowWidth > 767 && view === 'full' ? 'D MMM YYYY' : 'D MMM') 
                  : ''
              }}
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <!-- Visualizzazione in caso di template di progetto -->
    <div v-else class="wg-row com-anm22-tasks-project-bar">
      <router-link :to="'/project/'+projectData.id" class="wg-row" style="height:100%;">
        <div class="wg-col wg-xs-3" style="padding:10px;">
          <div class="com-anm22-app-text-m projectName" style="font-weight:bold;">
            {{ projectData.projectId || '-' }}
          </div>
        </div>
        <div class="wg-col wg-xs-6" style="padding:10px;" :title="projectHoverTitle(projectData)">
          <div class="com-anm22-app-text-m projectName" style="font-weight:bold;">
            {{ projectData.name || projectData.projectId || $anm22.strLang(lang, "Project", "Progetto") }}
          </div>
        </div>
        <div class="wg-col wg-xs-3 users-div">
          <div 
            v-for="(user,index) in projectUsers"
            :key="'u-'+index">
            <world-object-icon
              :type="'user'" 
              :obj="user"
              :isImg="true">
            </world-object-icon>
          </div>
          <div v-for="(job,index) in projectJobs" :key="'job'+index">
            <div :title="$anm22.strLang(lang, job.en, job.it)" class="job-icon"> {{ $anm22.strLang(lang, job.en, job.it).substring(0,1).toUpperCase() }} </div>
          </div>
        </div>
      </router-link>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    view: String,
    projectData: Object
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      windowWidth: state => state.windowWidth
    }),
    isSynchronized() {
      return this.$store.getters['offline/isSynchronized'](this.$anm22.MD5('WorldProject' + this.projectData.id));
    },
    borderColor() {
      switch (this.projectData.status) {
        case 1:
          return "#bdbdbd";
        case 2:
          return "#ffeb3b";
        case 3:
          return "#01d479";
        case 4:
          return "#00b0ff";
        case 5:
          return "#ff0000";
        case 6:
          return '#fff';
      }
    },
    projectUsers() {
      let ret = [];
      if(this.projectData.users){
        this.projectData.users.forEach(u => {
          ret.push(this.$store.getters['users/get'](u));
        });
      }
      return ret;
    },
    projectJobs(){
      let licenses = this.projectData.developers
      .map(w => this.$store.getters["licenses/get"](w))
      .filter(l => l);
      let jobs =  licenses.reduce(
        (acc, license) =>
          acc.concat(
            license.config && license.config.tasks && license.config.tasks.jobs
          ),
        []
      );
      return Object.keys(this.projectData.jobs).map(pJob =>
        jobs.find(j => j.id === pJob)
      )
    },
  },
  methods: {
    projectHoverTitle(projectData) {
      var title = '';
      if (projectData) {
        if (projectData.codeName) {
          title += projectData.codeName;
        } else {
          title += 'Progetto'
        }
        if (projectData.description) {
          title += "\n" + projectData.description;
        }
        if (projectData.tags && projectData.tags.length > 0) {
          title += "\n\n" + 'Tags:';
          this.projectTags(projectData).forEach((tag) => {title += "\n" + '- ' + tag.label});
        }
      }
      return title;
    },
    projectTags(projectData) {
      if (projectData.tags && projectData.tags.length > 0) {
        return projectData.tags
          .map((tId) => this.$store.getters["tags/get"](tId))
          .filter((t) => t && projectData.developers.includes(t.work));
      } else {
        return [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.status {
  font-size: 14px;
  width: 100%;
  height: 100%;
  padding: 10px 5px;
  box-sizing: border-box;
  margin-bottom: 0;
  &.waiting {
    background-color: #bdbdbd;
  }
  &.running {
    background-color: #ffeb3b;
  }
  &.completed {
    color: #fff;
    background-color: #01d479;
  }
  &.invoiced {
    color: #fff;
    background-color: #00b0ff;
  }
  &.canceled {
    color: #fff;
    background-color: #ff0000;
  }
  &.provisional {
    background-color: #fff;
  }
}
.users-div {
  display:flex;
  overflow:hidden;
  height:34px;
  flex-wrap:nowrap;
  align-items:center;
  white-space:nowrap;
  box-sizing:border-box;
  position: relative;
}
.users-div > div {
  position: absolute;
  min-width:26px;
  width:26px;
  height:26px;
  display: block;
  border: 2px solid #fff;
  border-radius: 13px;
  top:4px;
  left:0px;
}
.users-div > div:nth-child(1) {
  left:0px;
  z-index: 11;
}
.users-div > div:nth-child(2) {
  left:20px;
  z-index: 10;
}
.users-div > div:nth-child(3) {
  left:40px;
  z-index: 9;
}
.users-div > div:nth-child(4) {
  left:60px;
  z-index: 8;
}
.users-div > div:nth-child(5) {
  left:80px;
  z-index: 7;
}
.users-div > div:nth-child(6) {
  left:100px;
  z-index: 6;
}
.users-div > div:nth-child(7) {
  left:120px;
  z-index: 5;
}
.users-div > div:nth-child(8) {
  left:140px;
  z-index: 4;
}
.users-div > div:nth-child(9) {
  left:160px;
  z-index: 3;
}
.users-div > div:nth-child(10) {
  left:180px;
  z-index: 2;
}
.user-round-div {
  min-width:22px;
  width:22px;
  height:22px;
  border-radius:11px;
  padding-top:4px;
  margin:0 2px 0 0;
}
.date-div {
  flex-wrap:nowrap;
  align-items:center;
  justify-content:center;
  overflow:hidden;
  white-space:nowrap;
}
div.job-icon {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #007fff;
  border-radius: 50%;
  user-select: none;
  font-size: 14px;
}
.job-icon {
  width: 100%;
  height: 100%;
  padding: 0;
}
</style>

